<template>
  <div class="container">
    <HomeButton />
    <h1>Transaction History</h1>
    <!-- transaction disini -->
    <Loading v-if="loading" />
    <TransactionDetail
      v-for="transaction in transactions"
      :key="transaction.id"
      :transaction="transaction"
    />
    <div class="empty-transaction" v-if="transactions.length < 1">
      <h2>-- no transaction yet --</h2>
      <button class="btn btn-outline-secondary" @click="goToHome()">Continue Shopping</button>
    </div>
  </div>
</template>

<script>
import HomeButton from '@/components/HomeButton'
import TransactionDetail from '@/components/TransactionDetail.vue'
import Loading from '@/components/Loading.vue'
import { mapState } from 'vuex'

export default {
  components: {
    TransactionDetail,
    HomeButton,
    Loading
  },
  methods: {
    goToHome () {
      this.$router.push('/')
    }
  },
  created () {
    this.$store.dispatch('fetchTransaction')
  },
  computed: {
    ...mapState(
      [
        'transactions',
        'loading'
      ]
    )
  }
}
</script>

<style scoped>
  .empty-transaction {
    margin-top: 80px;
    color: gray;
    margin-bottom: 200px;
  }
</style>
